import { createFileRoute } from '@tanstack/react-router';
import { TrustLayout } from '../../components/trust/TrustLayout';

export const Route = createFileRoute('/trust/data-residency')({
  component: DataResidencyPage,
});

function DataResidencyPage() {
  return (
    <TrustLayout>
      <h1 className="mt-0 text-[22px] text-black">Data residency</h1>

      <h2 className="mt-6 text-base text-black">What stays in your tenant</h2>
      <ul className="text-black leading-loose">
        <li>The original file content for every imported document.</li>
        <li>Your Entra ID identity, group membership, and SharePoint role assignments.</li>
        <li>Site / drive / list metadata.</li>
        <li>Sensitivity labels and information-protection metadata.</li>
      </ul>

      <h2 className="mt-6 text-base text-black">What Repancy stores in Convex</h2>
      <ul className="text-black leading-loose">
        <li>Document records that link a SharePoint <code>itemId</code> to a Repancy matter.</li>
        <li>Etag + webUrl + sync cursor (delta link) for incremental sync.</li>
        <li>Audit log rows for every Graph write Repancy performs on your behalf.</li>
        <li>Cached document content with a short TTL (currently disabled in v1).</li>
      </ul>

      <h2 className="mt-6 text-base text-black">What Repancy never stores</h2>
      <ul className="text-black leading-loose">
        <li>Your Microsoft refresh token. MSAL keeps the cache in your browser sessionStorage; Convex never sees it.</li>
        <li>Your password. Authentication is via Microsoft's standard OAuth.</li>
        <li>Files outside the matters you explicitly imported.</li>
      </ul>

      <h2 className="mt-6 text-base text-black">Convex regions</h2>
      <p className="text-black leading-relaxed">
        Repancy currently runs on a single Convex deployment in <strong>us-east-1 (AWS)</strong>.
        EU residency is on the roadmap once Convex EU regions are generally available.
      </p>
    </TrustLayout>
  );
}
